import React, { useCallback, useState } from 'react';
import { View, Text, StyleSheet, TouchableWithoutFeedback } from 'react-native';
import { useDispatch } from 'react-redux';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { getUsersAllAddress } from '../../actions/ActionTypes';
import size from '../../theme/Fonts';
import colors from '../../theme/Colors';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import AddressCard from '../../containers/consumerProfile/Common/AddressCard';
import images from '../../theme/Images';
import Utility from '../../utils/Utility';
import { isBlank } from '../../utils/BooleanUtility';
import EmptyStateCard from '../../containers/consumerProfile/Common/EmptyStateCard';

const UserAddressesCard = (props) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const [myAddress, setMyAddress] = useState([]);
  const {
    itemData: { title = '' },
  } = props;

  const updateAddressIntoStateInitially = (addressArray) => {
    setMyAddress(addressArray);
  };

  const refreshAddress = (response) => {
    const combinedAddresses = [
      ...(response.ekanek_addresses || []).map((item) => item.attributes),
      ...(response.shopify_addresses || []),
    ];

    const sortedAddresses = combinedAddresses.sort((a, b) => b.id - a.id);

    const latestAddresses = sortedAddresses.slice(0, 4);

    updateAddressIntoStateInitially(latestAddresses);
  };

  const handleFetchResult = () => {
    dispatch(
      getUsersAllAddress((success, response) => {
        if (success) {
          refreshAddress(response);
        } else {
          console.tron.log('error in fetching address');
        }
      }),
    );
  };

  const updateAddress = (data) => {
    const address = myAddress;
    if (myAddress.length > 0) {
      address.unshift(data);
      setMyAddress(address);
    } else {
      address.unshift(data);
      updateAddressIntoStateInitially(address);
    }
  };

  const navigateToScreen = (type, element) => {
    switch (type) {
      case 'add_address':
        navigation.navigate('Address', {
          previousScreen: SCREEN_CONSTANTS.CONSUMER_PROFILE,
          updateAddress,
          addressToEdit: element,
          getAllAddress: handleFetchResult,
          showAddAddressScreen: true,
        });
        break;

      case 'edit_single_address':
        navigation.navigate('Address', {
          previousScreen: SCREEN_CONSTANTS.CONSUMER_PROFILE,
          updateAddress,
          addressToEdit: element,
          showDeleteButton: true,
          getAllAddress: handleFetchResult,
        });
        break;

      default:
        break;
    }
  };

  const getAddressIcon = (type) => {
    let icon = null;
    if (Utility.isBlank(type)) {
      return images.other_location;
    }
    if (type.toLowerCase() === 'home') {
      icon = images.home_building;
    } else if (
      type.toLowerCase() === 'office' ||
      type.toLowerCase() === 'work'
    ) {
      icon = images.office_building;
    } else {
      icon = images.other_location;
    }
    return icon;
  };

  const MyAdressesCard = () => {
    const sorted = myAddress.sort((a, b) => b.id - a.id);
    const rows = sorted
      .slice(0, 4)
      .map((element, position) => (
        <AddressCard
          locationIcon={getAddressIcon(element.name)}
          locationType={element.name || 'Others'}
          addressLine1={element.line1 ?? ''}
          addressLine2={element.line2 ?? ''}
          pincode={element.pincode ?? ''}
          address={element}
          isDefault={element.default}
          onEditAddress={() => navigateToScreen('edit_single_address', element)}
          source='ForYou'
        />
      ));
    return rows;
  };

  useFocusEffect(
    useCallback(() => {
      handleFetchResult();
    }, []),
  );

  if (isBlank(myAddress)) {
    return (
      <>
        <Text style={styles.emptyHeaderStyle}>{title}</Text>
        <View style={styles.sidePadding}>
          <EmptyStateCard
            backgroundColor={colors.white}
            leftAlignImage={false}
            headingText='Add an Address'
            subheadingText='Place orders quickly'
            imgSrc={images.empty_state_address}
            onPressCard={() => navigateToScreen('add_address')}
          />
        </View>
      </>
    );
  }

  return (
    <>
      <Text style={styles.headerStyle}>{title}</Text>
      <View style={styles.sidePadding}>
        <View style={styles.cardLayoutContainer}>
          <MyAdressesCard addresses={myAddress} />
          <TouchableWithoutFeedback
            onPress={() => navigateToScreen('add_address')}
          >
            <View style={styles.textContainer}>
              <Text style={styles.textStyle}>+ Add new address</Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  sidePadding: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  cardLayoutContainer: {
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: colors.white,
    borderWidth: 1,
    borderColor: colors.borderDark,
    borderRadius: 4,
  },
  textContainer: {
    paddingTop: 8,
    paddingBottom: 8,
    alignItems: 'flex-end',
  },
  textStyle: {
    fontFamily: 'Roboto-Medium',
    fontSize: size.h3,
    color: colors.cta.lightBlue,
    marginRight: 12,
  },
  headerStyle: {
    fontSize: 18,
    fontFamily: 'Roboto-Regular',
    color: colors.black,
    fontWeight: 'bold',
    marginLeft: 16,
  },
  emptyHeaderStyle: {
    fontSize: 18,
    fontFamily: 'Roboto-Regular',
    color: colors.black,
    fontWeight: 'bold',
    marginLeft: 16,
    marginVertical: 12,
  },
});

export default UserAddressesCard;
